export default {
  "filter": {
    "title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Produkte der Produktgruppe „", _interpolate(_named("group")), "“"])},
    "type": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Typ"])}
    },
    "apply": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter anwenden"])},
    "reset": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ALLE ZURÜCKSETZEN"])}
  },
  "results": {
    "counter": {
      "info": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["<b>", _interpolate(_named("loaded")), "</b> von <b>", _interpolate(_named("total")), "</b> Produkte werden ausgegeben"])},
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<b>Produkte</b> pro Seite"])}
    },
    "model": {
      "attributes": {
        "id": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modell"])}
        }
      }
    },
    "pagination": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Seite <b>", _interpolate(_named("current")), "</b> von <b>", _interpolate(_named("total")), "</b>"])}
  }
}